import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  inject,
  input,
  NgZone,
  Output,
  viewChild,
} from '@angular/core';
import { ReactWrapperComponent } from '@examdojo/core/react-wrapper';
import { EMOJIS } from '@examdojo/core/tiptap';
import {
  IconPicker,
  type IconPickerSelection,
} from '@examdojo/core/tiptap-react-ui-components/components/tiptap-ui/icon-picker/icon-picker';
import type { IconPickerTab } from '@examdojo/core/tiptap-react-ui-components/components/tiptap-ui/icon-picker/icon-picker-constants';
import { createElement, type ReactElement } from 'react';

@Component({
  selector: 'dojo-icon-picker-wrapper',
  standalone: true,
  template: `<div #mount></div>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconPickerWrapperComponent extends ReactWrapperComponent {
  private readonly zone = inject(NgZone);

  readonly mountElementRef = viewChild.required<ElementRef>('mount');

  readonly initialTab = input<IconPickerTab>('fontawesome');
  readonly initialFaColor = input<string | undefined>(undefined);
  readonly initialShowBackground = input<boolean>(true);
  readonly activeIconValue = input<string | undefined>(undefined);

  @Output() readonly iconSelected = new EventEmitter<IconPickerSelection>();

  protected readonly reRenderTriggers: never[] = [];

  protected renderReactElement(): ReactElement {
    return createElement(IconPicker, {
      emojis: EMOJIS,
      onSelect: (selection: IconPickerSelection) => {
        this.zone.run(() => {
          this.iconSelected.emit(selection);
        });
      },
      onSettingsChange: (selection: IconPickerSelection) => {
        this.zone.run(() => {
          this.iconSelected.emit(selection);
        });
      },
      showSearch: true,
      initialTab: this.initialTab(),
      initialFaColor: this.initialFaColor(),
      initialShowBackground: this.initialShowBackground(),
      activeIconValue: this.activeIconValue(),
    });
  }
}
